"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.consume = consume;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

let warnedCallbackDeprecation = false;

const warnCallbackDeprecation = () => {
  if (!warnedCallbackDeprecation) {
    console.warn(`\`${'consume'}(callback, iterable)\` is deprecated and will be removed in iter-tools@8. ` + `Instead use ${'forEach'}(callback, iterable)`);
    warnedCallbackDeprecation = true;
  }
};

function consume(iterable, callback = () => {}) {
  let c = 0;

  for (const item of iterable) {
    callback(item, c++);
  }
}

var _default = (0, _iterable.iterableCurry)(consume, {
  reduces: true,
  minArgs: 0,
  maxArgs: 1,

  validateArgs(args) {
    if (typeof args[0] === 'function') {
      warnCallbackDeprecation();
    }
  }

});

exports.default = _default;